import { useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import useFiltersState from '../state/useFiltersState';
import { useUserAuth } from '../state/userAuthContext';
import { ordersRoutes } from './allRoutes';

const switchRoutes = (
  <Switch>
    {ordersRoutes.map((prop, key) => {
      if (prop.layout === 'order') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/order" to="/tracking-order/main" />
  </Switch>
);

const Orders = () => {
  const { user } = useUserAuth();
  const { setOrdersFilters, setOrdersSearchbarText, setSecondOrdersFilters, setSecondOrdersSearchbarText } =
    useFiltersState();

  useEffect(() => {
    return () => {
      setOrdersFilters([]);
      setSecondOrdersFilters([]);
      setOrdersSearchbarText('');
      setSecondOrdersSearchbarText('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <> {user && switchRoutes} </>;
};

export default Orders;
